module.exports = __webpack_public_path__ + "static/img/kangle.ba2fc73.png";


//////////////////
// WEBPACK FOOTER
// ./static/kangle.png
// module id = D15I
// module chunks = 1